import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NzSkeletonComponent} from 'ng-zorro-antd/skeleton';
import {ACCESS_TOKEN_KEY} from '../../models/storageKeys';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-forward',
    imports: [
        NzSkeletonComponent
    ],
    template: `
    <nz-skeleton [nzLoading]="true"></nz-skeleton>
  `,
    styles: ``
})
export class ForwardComponent implements OnInit {

  constructor(private actRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    const {module} = this.actRoute.snapshot.queryParams;
    const token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
    const url = `${environment.portalUrl}/${token}?module=${module}`;
    window.location.replace(url);
  }
}
